import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Missing application root');

const isCustomAdminHost = window.location.hostname === 'admin.cottage-events.com';
const isOrganiserRoute =
  window.location.pathname === '/organiser' || window.location.pathname.startsWith('/organiser/');

if (isCustomAdminHost && !isOrganiserRoute) {
  window.location.replace('/login/');
} else {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
